import type { HackerOnboardingAdditionalInfo } from '@/types';
import { AdditionalInfoForm } from './components/AdditionalInfoForm';

// additional-info/page.tsx — the standalone copy of the step the dispatcher also renders.
export default function AdditionalInfo({
  edition,
  countryOptions,
  defaultCountry,
}: HackerOnboardingAdditionalInfo) {
  return (
    <AdditionalInfoForm
      edition={edition}
      countryOptions={countryOptions}
      defaultCountry={defaultCountry}
    />
  );
}
